import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useDeleteLeasingPlanMutation } from '@telialt/core-eshop/src/hooks/mutations/useDeleteLeasingPlanMutation';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import {
    selectDiscountPrice,
    selectIsFullPricePayment,
    selectProductBasePrice,
} from '@telialt/utils/src/eshopSelectors';
import { withParams } from '@telialt/utils/src/helpers';

import { LEASING_SELECTOR_RADIO_GROUP_NAME } from './constants';
import {
    FullPriceRadioOptionWrapper,
    LabelDiscountPrice,
    LabelMonthlyPrice,
    Radio,
} from './LeasingPlanSelector.styles';

export const RadioFullPriceOption: FC = () => {
    const { t } = useTranslations();
    const { cart } = useCartQuery();
    const { deleteLeasingPlan } = useDeleteLeasingPlanMutation();

    const productBasePrice = selectProductBasePrice(cart);
    const productDiscountPrice = selectDiscountPrice(cart);

    const handleSwitchToFullPricePayment = () => deleteLeasingPlan();

    return (
        <FullPriceRadioOptionWrapper>
            <Radio
                checked={selectIsFullPricePayment(cart)}
                onChange={handleSwitchToFullPricePayment}
                name={LEASING_SELECTOR_RADIO_GROUP_NAME}
                value="full-price"
                label={t['eshop.product_page.leasing_selector.full_price_option']}
            />
            <LabelDiscountPrice>
                {productDiscountPrice?.value > 0 &&
                    withParams(t['eshop.product_page.leasing_selector.discount'], {
                        discount: productDiscountPrice.formattedValue,
                    })}
            </LabelDiscountPrice>
            <LabelMonthlyPrice>{productBasePrice?.formattedValue}</LabelMonthlyPrice>
        </FullPriceRadioOptionWrapper>
    );
};
